import moment from "moment"
import {ParticipantEntry} from "./participant.types"

export type ParticipantStatus =
    | "NOT_BOOKED"
    | "BOOKED"
    | "ATTENDED"
    | "NOT_ATTENDED"

export const getParticipantStatus = (
    entry: ParticipantEntry
): ParticipantStatus => {
    if (!entry.booking) {
        return "NOT_BOOKED"
    }

    if (entry.booking.state === "QUIT") {
        return "ATTENDED"
    }

    if (
        entry.booking.state === "BOOKED" &&
        entry.booking.bookingSlot &&
        moment().isBefore(
            moment(entry.booking.bookingSlot.entryAt)
        )
    ) {
        return "BOOKED"
    }

    return "NOT_ATTENDED"
}

export const getParticipantStatusLabel = (
    entry: ParticipantEntry,
    t: (key: string) => string
): string => {
    const status = getParticipantStatus(entry)

    if (status === "NOT_BOOKED") return t("participants.status.notBooked")
    if (status === "BOOKED") return t("participants.status.booked")
    if (status === "ATTENDED") return t("participants.status.attended")
    return t("participants.status.missed")
}

export const getParticipantStatusFilterValue = (
    entry: ParticipantEntry
): string => {
    const status = getParticipantStatus(entry)

    if (status === "BOOKED") return "0"
    if (status === "ATTENDED") return "1"
    if (status === "NOT_ATTENDED") return "2"
    return "3"
}
